import axios from 'axios';
import { BASE_URL, ENDPOINTS } from './endpointConstant';


export const registerUser = async (credentials) => {
  const response = await axios.post(`${BASE_URL}${ENDPOINTS.AUTH.REGISTER}`, credentials);
  return response.data;
};

export const loginUser = async (credentials) => {
  const response = await axios.post(`${BASE_URL}${ENDPOINTS.AUTH.LOGIN}`, credentials);
  return response.data;
};


export default ENDPOINTS;